/* 👻🚨👻🚨👻 Let op! This code has been auto generated, so best not to touch it 👻🚨👻🚨👻 */
import * as Types from '../types';

import type { FetchOptions } from "../fetcher/fetcher.types"
import { useQuery, useSuspenseQuery, useInfiniteQuery, useSuspenseInfiniteQuery, useMutation, UseQueryOptions, UseSuspenseQueryOptions, UseInfiniteQueryOptions, InfiniteData, UseSuspenseInfiniteQueryOptions, UseMutationOptions } from '@tanstack/react-query';
import { fetcher } from '../fetcher/index';
export type ContentFetchReviewsQueryVariables = Types.Exact<{
  input: Types.ContentProductReviewsInput;
}>;


export type ContentFetchReviewsQuery = { __typename?: 'Query', contentProductReviews: { __typename?: 'ContentProductReviews', cursor: string, rating: { __typename?: 'ContentReviewRating', average: number, count: number, groups: Array<{ __typename?: 'ContentReviewRatingGroup', rating: number, count: number }> }, reviews: Array<{ __typename?: 'ContentReview', id: string, parentId?: string | null, userId: string, rating?: number | null, body: string, createdAt: any, user: { __typename?: 'PublicUserProfile', id: string, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, profileUrls?: { __typename?: 'PublicUserProfileUrls', crafter?: string | null } | null } }> } };

export type StudioProjectDownloadAssetsQueryVariables = Types.Exact<{
  input: Types.StudioProjectDownloadAssetsInput;
}>;


export type StudioProjectDownloadAssetsQuery = { __typename?: 'Query', studioProjectDownloadAssets: { __typename?: 'StudioProjectDownloadAssetsResponse', assets: Array<{ __typename?: 'AssetDownloadResponse', url: string, product: { __typename?: 'ContentProduct', id: string } }>, errors: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> } };

export type ContentIncreaseDownloadCountMutationVariables = Types.Exact<{
  productId: Types.Scalars['ID']['input'];
  source?: Types.InputMaybe<Types.ContentDownloadSource>;
}>;


export type ContentIncreaseDownloadCountMutation = { __typename?: 'Mutation', contentIncreaseDownloadCount: boolean };

export type ContentCountFavoritesQueryVariables = Types.Exact<{
  productId: Types.Scalars['ID']['input'];
}>;


export type ContentCountFavoritesQuery = { __typename?: 'Query', contentCountFavorites: { __typename?: 'ContentProductFavoriteCount', total: number, users: Array<{ __typename?: 'PublicUserProfile', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, profileUrls?: { __typename?: 'PublicUserProfileUrls', crafter?: string | null } | null }> } };



export const ContentFetchReviewsDocument = /*#__PURE__*/ `
    query contentFetchReviews($input: ContentProductReviewsInput!) {
  contentProductReviews(input: $input) {
    rating {
      average
      count
      groups {
        rating
        count
      }
    }
    cursor
    reviews {
      id
      parentId
      userId
      rating
      body
      createdAt
      user {
        id
        firstName
        lastName
        avatarUrl
        profileUrls {
          crafter
        }
      }
    }
  }
}
    `;

export const useContentFetchReviewsQuery = <
      TData = ContentFetchReviewsQuery,
      TError = unknown
    >(
      variables: ContentFetchReviewsQueryVariables,
      options?: Omit<UseQueryOptions<ContentFetchReviewsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ContentFetchReviewsQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useQuery<ContentFetchReviewsQuery, TError, TData>(
      {
    queryKey: ['contentFetchReviews', variables],
    queryFn: fetcher<ContentFetchReviewsQuery, ContentFetchReviewsQueryVariables>(ContentFetchReviewsDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useContentFetchReviewsQuery.document = ContentFetchReviewsDocument;

useContentFetchReviewsQuery.getKey = (variables: ContentFetchReviewsQueryVariables) => ['contentFetchReviews', variables];

useContentFetchReviewsQuery.rootKey = 'contentFetchReviews';

export const useSuspenseContentFetchReviewsQuery = <
      TData = ContentFetchReviewsQuery,
      TError = unknown
    >(
      variables: ContentFetchReviewsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ContentFetchReviewsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ContentFetchReviewsQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useSuspenseQuery<ContentFetchReviewsQuery, TError, TData>(
      {
    queryKey: ['contentFetchReviewsSuspense', variables],
    queryFn: fetcher<ContentFetchReviewsQuery, ContentFetchReviewsQueryVariables>(ContentFetchReviewsDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useSuspenseContentFetchReviewsQuery.document = ContentFetchReviewsDocument;

useSuspenseContentFetchReviewsQuery.getKey = (variables: ContentFetchReviewsQueryVariables) => ['contentFetchReviewsSuspense', variables];

useSuspenseContentFetchReviewsQuery.rootKey = 'contentFetchReviews';

export const useInfiniteContentFetchReviewsQuery = <
      TData = InfiniteData<ContentFetchReviewsQuery>,
      TError = unknown
    >(
      variables: ContentFetchReviewsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ContentFetchReviewsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ContentFetchReviewsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ContentFetchReviewsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['contentFetchReviews.infinite', variables],
      queryFn: (metaData) => fetcher<ContentFetchReviewsQuery, ContentFetchReviewsQueryVariables>(ContentFetchReviewsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteContentFetchReviewsQuery.getKey = (variables: ContentFetchReviewsQueryVariables) => ['contentFetchReviews.infinite', variables];

useInfiniteContentFetchReviewsQuery.rootKey = 'contentFetchReviews.infinite';

export const useSuspenseInfiniteContentFetchReviewsQuery = <
      TData = InfiniteData<ContentFetchReviewsQuery>,
      TError = unknown
    >(
      variables: ContentFetchReviewsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<ContentFetchReviewsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<ContentFetchReviewsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<ContentFetchReviewsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['contentFetchReviews.infiniteSuspense', variables],
      queryFn: (metaData) => fetcher<ContentFetchReviewsQuery, ContentFetchReviewsQueryVariables>(ContentFetchReviewsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteContentFetchReviewsQuery.getKey = (variables: ContentFetchReviewsQueryVariables) => ['contentFetchReviews.infiniteSuspense', variables];

useSuspenseInfiniteContentFetchReviewsQuery.rootKey = 'contentFetchReviews.infinite';


useContentFetchReviewsQuery.fetcher = (variables: ContentFetchReviewsQueryVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<ContentFetchReviewsQuery, ContentFetchReviewsQueryVariables>(ContentFetchReviewsDocument, variables, options, fetchOptions);

export const StudioProjectDownloadAssetsDocument = /*#__PURE__*/ `
    query studioProjectDownloadAssets($input: StudioProjectDownloadAssetsInput!) {
  studioProjectDownloadAssets(input: $input) {
    assets {
      url
      product {
        id
      }
    }
    errors {
      code
      message
    }
  }
}
    `;

export const useStudioProjectDownloadAssetsQuery = <
      TData = StudioProjectDownloadAssetsQuery,
      TError = unknown
    >(
      variables: StudioProjectDownloadAssetsQueryVariables,
      options?: Omit<UseQueryOptions<StudioProjectDownloadAssetsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<StudioProjectDownloadAssetsQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useQuery<StudioProjectDownloadAssetsQuery, TError, TData>(
      {
    queryKey: ['studioProjectDownloadAssets', variables],
    queryFn: fetcher<StudioProjectDownloadAssetsQuery, StudioProjectDownloadAssetsQueryVariables>(StudioProjectDownloadAssetsDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useStudioProjectDownloadAssetsQuery.document = StudioProjectDownloadAssetsDocument;

useStudioProjectDownloadAssetsQuery.getKey = (variables: StudioProjectDownloadAssetsQueryVariables) => ['studioProjectDownloadAssets', variables];

useStudioProjectDownloadAssetsQuery.rootKey = 'studioProjectDownloadAssets';

export const useSuspenseStudioProjectDownloadAssetsQuery = <
      TData = StudioProjectDownloadAssetsQuery,
      TError = unknown
    >(
      variables: StudioProjectDownloadAssetsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<StudioProjectDownloadAssetsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<StudioProjectDownloadAssetsQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useSuspenseQuery<StudioProjectDownloadAssetsQuery, TError, TData>(
      {
    queryKey: ['studioProjectDownloadAssetsSuspense', variables],
    queryFn: fetcher<StudioProjectDownloadAssetsQuery, StudioProjectDownloadAssetsQueryVariables>(StudioProjectDownloadAssetsDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useSuspenseStudioProjectDownloadAssetsQuery.document = StudioProjectDownloadAssetsDocument;

useSuspenseStudioProjectDownloadAssetsQuery.getKey = (variables: StudioProjectDownloadAssetsQueryVariables) => ['studioProjectDownloadAssetsSuspense', variables];

useSuspenseStudioProjectDownloadAssetsQuery.rootKey = 'studioProjectDownloadAssets';

export const useInfiniteStudioProjectDownloadAssetsQuery = <
      TData = InfiniteData<StudioProjectDownloadAssetsQuery>,
      TError = unknown
    >(
      variables: StudioProjectDownloadAssetsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<StudioProjectDownloadAssetsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<StudioProjectDownloadAssetsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<StudioProjectDownloadAssetsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['studioProjectDownloadAssets.infinite', variables],
      queryFn: (metaData) => fetcher<StudioProjectDownloadAssetsQuery, StudioProjectDownloadAssetsQueryVariables>(StudioProjectDownloadAssetsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteStudioProjectDownloadAssetsQuery.getKey = (variables: StudioProjectDownloadAssetsQueryVariables) => ['studioProjectDownloadAssets.infinite', variables];

useInfiniteStudioProjectDownloadAssetsQuery.rootKey = 'studioProjectDownloadAssets.infinite';

export const useSuspenseInfiniteStudioProjectDownloadAssetsQuery = <
      TData = InfiniteData<StudioProjectDownloadAssetsQuery>,
      TError = unknown
    >(
      variables: StudioProjectDownloadAssetsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<StudioProjectDownloadAssetsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<StudioProjectDownloadAssetsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<StudioProjectDownloadAssetsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['studioProjectDownloadAssets.infiniteSuspense', variables],
      queryFn: (metaData) => fetcher<StudioProjectDownloadAssetsQuery, StudioProjectDownloadAssetsQueryVariables>(StudioProjectDownloadAssetsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteStudioProjectDownloadAssetsQuery.getKey = (variables: StudioProjectDownloadAssetsQueryVariables) => ['studioProjectDownloadAssets.infiniteSuspense', variables];

useSuspenseInfiniteStudioProjectDownloadAssetsQuery.rootKey = 'studioProjectDownloadAssets.infinite';


useStudioProjectDownloadAssetsQuery.fetcher = (variables: StudioProjectDownloadAssetsQueryVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<StudioProjectDownloadAssetsQuery, StudioProjectDownloadAssetsQueryVariables>(StudioProjectDownloadAssetsDocument, variables, options, fetchOptions);

export const ContentIncreaseDownloadCountDocument = /*#__PURE__*/ `
    mutation contentIncreaseDownloadCount($productId: ID!, $source: ContentDownloadSource) {
  contentIncreaseDownloadCount(productId: $productId, source: $source)
}
    `;

export const useContentIncreaseDownloadCountMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ContentIncreaseDownloadCountMutation, TError, ContentIncreaseDownloadCountMutationVariables, TContext>, headers?: Headers, fetchOptions?: FetchOptions) => {
    
    return useMutation<ContentIncreaseDownloadCountMutation, TError, ContentIncreaseDownloadCountMutationVariables, TContext>(
      {
    mutationKey: ['contentIncreaseDownloadCount'],
    mutationFn: (variables?: ContentIncreaseDownloadCountMutationVariables) => fetcher<ContentIncreaseDownloadCountMutation, ContentIncreaseDownloadCountMutationVariables>(ContentIncreaseDownloadCountDocument, variables, headers, fetchOptions)(),
    ...options
  }
    )};

useContentIncreaseDownloadCountMutation.getKey = () => ['contentIncreaseDownloadCount'];


useContentIncreaseDownloadCountMutation.fetcher = (variables: ContentIncreaseDownloadCountMutationVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<ContentIncreaseDownloadCountMutation, ContentIncreaseDownloadCountMutationVariables>(ContentIncreaseDownloadCountDocument, variables, options, fetchOptions);

export const ContentCountFavoritesDocument = /*#__PURE__*/ `
    query contentCountFavorites($productId: ID!) {
  contentCountFavorites(productId: $productId) {
    total
    users {
      firstName
      lastName
      profileUrls {
        crafter
      }
      avatarUrl
    }
  }
}
    `;

export const useContentCountFavoritesQuery = <
      TData = ContentCountFavoritesQuery,
      TError = unknown
    >(
      variables: ContentCountFavoritesQueryVariables,
      options?: Omit<UseQueryOptions<ContentCountFavoritesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ContentCountFavoritesQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useQuery<ContentCountFavoritesQuery, TError, TData>(
      {
    queryKey: ['contentCountFavorites', variables],
    queryFn: fetcher<ContentCountFavoritesQuery, ContentCountFavoritesQueryVariables>(ContentCountFavoritesDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useContentCountFavoritesQuery.document = ContentCountFavoritesDocument;

useContentCountFavoritesQuery.getKey = (variables: ContentCountFavoritesQueryVariables) => ['contentCountFavorites', variables];

useContentCountFavoritesQuery.rootKey = 'contentCountFavorites';

export const useSuspenseContentCountFavoritesQuery = <
      TData = ContentCountFavoritesQuery,
      TError = unknown
    >(
      variables: ContentCountFavoritesQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ContentCountFavoritesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ContentCountFavoritesQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useSuspenseQuery<ContentCountFavoritesQuery, TError, TData>(
      {
    queryKey: ['contentCountFavoritesSuspense', variables],
    queryFn: fetcher<ContentCountFavoritesQuery, ContentCountFavoritesQueryVariables>(ContentCountFavoritesDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useSuspenseContentCountFavoritesQuery.document = ContentCountFavoritesDocument;

useSuspenseContentCountFavoritesQuery.getKey = (variables: ContentCountFavoritesQueryVariables) => ['contentCountFavoritesSuspense', variables];

useSuspenseContentCountFavoritesQuery.rootKey = 'contentCountFavorites';

export const useInfiniteContentCountFavoritesQuery = <
      TData = InfiniteData<ContentCountFavoritesQuery>,
      TError = unknown
    >(
      variables: ContentCountFavoritesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ContentCountFavoritesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ContentCountFavoritesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ContentCountFavoritesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['contentCountFavorites.infinite', variables],
      queryFn: (metaData) => fetcher<ContentCountFavoritesQuery, ContentCountFavoritesQueryVariables>(ContentCountFavoritesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteContentCountFavoritesQuery.getKey = (variables: ContentCountFavoritesQueryVariables) => ['contentCountFavorites.infinite', variables];

useInfiniteContentCountFavoritesQuery.rootKey = 'contentCountFavorites.infinite';

export const useSuspenseInfiniteContentCountFavoritesQuery = <
      TData = InfiniteData<ContentCountFavoritesQuery>,
      TError = unknown
    >(
      variables: ContentCountFavoritesQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<ContentCountFavoritesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<ContentCountFavoritesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<ContentCountFavoritesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['contentCountFavorites.infiniteSuspense', variables],
      queryFn: (metaData) => fetcher<ContentCountFavoritesQuery, ContentCountFavoritesQueryVariables>(ContentCountFavoritesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteContentCountFavoritesQuery.getKey = (variables: ContentCountFavoritesQueryVariables) => ['contentCountFavorites.infiniteSuspense', variables];

useSuspenseInfiniteContentCountFavoritesQuery.rootKey = 'contentCountFavorites.infinite';


useContentCountFavoritesQuery.fetcher = (variables: ContentCountFavoritesQueryVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<ContentCountFavoritesQuery, ContentCountFavoritesQueryVariables>(ContentCountFavoritesDocument, variables, options, fetchOptions);
